import { gql } from '__generated__/gql';
import { ApolloCache } from '@apollo/client';

export const GLOBAL_SETTINGS_QUERY = gql(`
  query GlobalSettings {
    globalSettings {
      id
      offerSeminargoApprovalEnabled
    }
  }
`);

export const OFFER_SEMINARGO_APPROVAL_ENABLED_QUERY = gql(`
  query OfferSeminargoApprovalEnabled {
    offerSeminargoApprovalEnabled
  }
`);

export const OFFERVERSION_LIST_SHORT_FRAGMENT = gql(`
  fragment WLOfferVersionListShort on WLOfferVersionListOutput {
    id
    createdAt
    displayCreatedAt 
    status
    type
    offer {
      id
      refCode
      status
      source
      deleteReason
      bookingTitle
      publicCompany {
        id
        name
        isPremium
      }
    }
    hotel {
      id
      name
      spaceId
    }
    input {
      id
      startDate
      endDate
    }
    inputLister {
      id
      startDate
      endDate
    }
    client {
      id
      firstname
      lastname
      company
    }
    personalMessage
  }
`);

export const OFFERVERSION_DIFF_FRAGMENT = gql(`
  fragment WLOfferVersionDiffOutput on WLOfferVersionListOutput {
    diffToApproved {
      requiresHotelApproval
      startDateChanged { fromStartDate toStartDate }
      diff {
        day
        diffs {
          sku
          header
          sequenceIndex
          hasPriceDiff
          priceDiffs { priceItem1 priceItem2 priceNet1 priceNet2 priceGross1 priceGross2 }
          hasCountDiff
          count1
          count2
          requiresHotelApproval
        }
      }
    }
  }
`);




export const OFFERVERSION_LIST_VIEW_FRAGMENT = gql(`
  fragment WLOfferVersionListView on WLOfferVersionListOutput {
    id
    createdAt
    updatedAt
    version
    extRefCode
    extRefData
    status
    offerDate
    startDate
    title
    type
    filename
    cssStyles
    marginTop
    marginBottom
    marginLeft
    marginRight
    includeEmptyLineItems
    headerTemplate
    footerTemplate
    agreedCancellationWaiveNet
    manualCancellationWaiveNet
    totalPriceNet
    totalPriceGross
    additionalInfo1
    additionalInfo2
    additionalInfo3
    personalMessage
    hotelMessage
    requestFiles {
      id
      originalFilename
      mimeType
      fileSize
    }
    space { ...SpaceShort }
    hotel {
      id
      name
      refCode
      spaceId
      businessName
      businessAddress1
      businessAddress2
      businessAddress3
      businessAddress4
      businessCountry
      businessZip
      businessCity
      businessState
      integrations { id secret { id system } }
      contracts { id type validFrom validTo}
      offerExpirationDays
      maxCapacityRooms
      maxCapacityPeople
      contracts { 
        id
        type
        isActive
        validFrom
        validTo
      }
      commissionRates {
        id
        customerType
        commissionBase
        commissionPercentage
        validFrom
        remark
      }
      cancellationRules {
        id
        daysToEvent
        rate
        minOvernight
        maxOvernight
        minTotalGuests
        maxTotalGuests
        toleranceRate
      }
      cancellationToleranceRate
    }
    offer {
      id
      refCode
      language
      status
      source
      process
      cancellationToleranceRate
      commissionBase
      commissionPercentage
      cancellationRules {
        id
        daysToEvent
        rate
      }
      downpaymentDueDate
      downpaymentAmount
      downpaymentRemark
      publicCompany {
        id
        name
        isPremium
        country
      }
      publicClient {
      id
      firstname
      lastname
      email
      }
    }
    input {
      language
      startDate
      endDate
      prevdayGuests
      comment
      serviceType {
        serviceTypeId
        sku
        name
        header
        details
      }
      days {
        day
        addons {
          count
          sku
          header
          product { id name }
          facility { id name }
        }
        occupancy {
          room
          occupancy
          seating
        }
        overnightGuests
        totalGuests
      }
    }
    inputLister {
      language
      startDate
      endDate
      comment
      days {
        day
        addons {
          count
          lookupCode
          header
          product { id name }
        }
        occupancy {
          room
          occupancyTo
          occupancyFrom
          seating
          seatingDescription
          seatCount
          requireAirConditioning
          requireDaylight
          minRoomAreaSqm
          beamerCount
          flipchartCount
          pinboardCount
        }
        overnightRoomsEZ
        overnightRoomsDZ
        totalGuests
      }
    }
    priceList {
      id
      name
      currency
      isPricesNet
    }
    client {
      id
      firstname
      lastname
      company
      email
      address
      city
      zip
      country
      phone
      billingCompany
      billingFirstname
      billingLastname
      billingAddress
      billingCity
      billingZip
      billingCountry
    }
    contentBlocks {
      id
      type
      template
      sequence
      blockDescription
      formFields {
        id
        type
        name
        label
        value
        sequence
        required
        placeholder
      }
      cancellationRule {
        id
        daysToEvent
        rate
      }
      lineItems {
        id
        day
        sku
        spaceId
        header
        details
        count
        priceItem
        priceNet
        priceGross
        sequence
        source
        guaranteedRoomAreaSqm
        confirmAirConditioning
        confirmDaylight
        requirementsAcknowledged
        offeredSeatCount
        offeredFrom
        offeredTo
        offeredSeating
        offeredBeamerCount
        offeredFlipchartCount
        offeredPinboardCount
        media {
          id
          name
          mimeType
          size
        }
        components {
          price
          type {
            id
            name
            lookupCode
          }
        }
        taxes {
          price
          type {
            id
            name
            lookupCode
          }
          rate {
            id
            rate
          }
        }
        invoice {
          invoicingRule
          commission
          costCentre
          accountingArea
        }
      }
    }
    taxes {
      price
      type {
        id
        name
        lookupCode
      }        
      rate {
        id
        rate
      }
    }
  }
`);

export const OFFER_HISTORY_DETAIL_SERVICE_FRAGMENT = gql(`
  fragment WLOfferHistoryDetailService on WLOfferHistoryDetailServiceOutput {
    id
    createdAt
    updatedAt
    spaceId
    changeDate
    sku
    serviceName
    lookupCode
    previousCount
    newCount
    changeCount
    dayId
    comment
    displayName
    changeType
    productId
    bundleId
    facilityId
    serviceTypeId
  }
`);

export const OFFER_HISTORY_DETAIL_ATTENDEE_FRAGMENT = gql(`
  fragment WLOfferHistoryDetailAttendee on WLOfferHistoryDetailAttendeeOutput {
    id
    createdAt
    updatedAt
    spaceId
    changeDate
    attendeeName
    fieldName
    oldValue
    newValue
    changeType
    dayId
    comment
    displayName
  }
`);

export const OFFER_HISTORY_DETAIL_PLANNING_FRAGMENT = gql(`
  fragment WLOfferHistoryDetailPlanning on WLOfferHistoryDetailPlanningOutput {
    id
    createdAt
    updatedAt
    spaceId
    changeDate
    changeType
    changeCategory
    fieldName
    oldValue
    newValue
    dayId
    entityId
    comment
    displayName
  }
`);

export const OFFER_HISTORY_DETAIL_BILLING_FRAGMENT = gql(`
  fragment WLOfferHistoryDetailBilling on WLOfferHistoryDetailBillingOutput {
    id
    createdAt
    updatedAt
    spaceId
    changeDate
    fieldName
    fieldDisplayName
    oldValue
    newValue
    changeType
    dayId
    comment
    displayName
  }
`);

export const OFFER_HISTORY_LIST_SHORT_FRAGMENT = gql(`
  fragment WLOfferHistoryListShort on WLOfferHistoryListOutput {
    id
    createdAt
    status
    extraInfo
    userType
    rejectionReasonCode
    rejectionReasonText
    offerVersion {
      id
      version
      status
      startDate
    }
    user {
      id
      name
      spaceId
    }
    publicClient {
      id
      firstname
      lastname
      publicCompany {
        id
        name
      }
    }
    serviceDetails {
      ...WLOfferHistoryDetailService
    }
    attendeeDetails {
      ...WLOfferHistoryDetailAttendee
    }
    planningDetails {
      ...WLOfferHistoryDetailPlanning
    }
    billingDetails {
      ...WLOfferHistoryDetailBilling
    }
  }
`);

export const OFFER_LIST_SHORT_FRAGMENT = gql(`
  fragment WLOfferListShort on WLOfferListOutput {
    id
    createdAt
    updatedAt
    status
    source
    process
    language
    refCode
    deleteReason
    space { ...SpaceShort }
    hotel {
      id
      name
      spaceId
      integrations { id }
    }
  }
`);

export const OFFER_LIST_VIEW_FRAGMENT = gql(`
  fragment WLOfferListView on WLOfferListOutput {
    id
    createdAt
    status
    source
    process
    language
    refCode
    bookingId
    bookingTitle
    commissionBase
    commissionPercentage
    space { ...SpaceShort }
    hotel {
      id
      name
      spaceId
      businessCountry
      integrations { id }
    }
    publicCompany {
      id
      name
      isPremium
    }
    history {
      ...WLOfferHistoryListShort
    }
    emailHistory {
      ...EmailHistoryOutputShort
    }
    responsibleUser {
      id
      name
      email
    }
  }
`);

export const OFFERVERSIONS_LIST_IDS_QUERY = gql(`
  query ListWlOfferVersionsIds($filters: [WLOfferVersionFilterInput!]!, $sortColumn: String, $sortDirection: String, $skip: Int, $take: Int) {
    listWlOfferVersions(filters: $filters, sortColumn: $sortColumn, sortDirection: $sortDirection, skip: $skip, take: $take) {
      id
    }
  }
`);

export const OFFERVERSIONS_LIST_BY_IDS_QUERY = gql(`
  query ListWlOfferVersionsByIds($ids: [Int!]!) {
    listWlOfferVersionsByIds(ids: $ids) {
      ...WLOfferVersionListShort
    }
  }
`);

export const REPORT_OFFERLIST_QUERY = gql(`
  query ReportOfferList($skip: Int, $take: Int, $filters: OffersReportFiltersInput!) {
    reportOffersList(skip: $skip, take: $take, filters: $filters) {
      ...WLOfferListView
    }
    reportOffersListCount(filters: $filters)
  }
`);

export const OFFER_VIEW_QUERY = gql(`
  query ViewWlOffer($id: Int!) {
    viewWlOffer(id: $id) {
      ...WLOfferListView
    }
    viewWlOfferLatestVersion(offerId: $id) {
      ...WLOfferVersionListView
      ...WLOfferVersionDiffOutput
    }
  }
`);

export const GUEST_OFFER_HEADER_QUERY = gql(`
  query GuestOfferHeader($id: Int!) {
    viewWlOffer(id: $id) {
      hotel {
        name
      }
    }
  }
`);

export const OFFER_AND_VERSION_VIEW_QUERY = gql(`
  query ViewWlOfferAndVersion($id: Int!, $versionId: Int!) {
    viewWlOffer(id: $id) {
      ...WLOfferListView
    }
    viewWlOfferVersion(id: $versionId) {
      ...WLOfferVersionListView
      ...WLOfferVersionDiffOutput
    }
  }
`);

export const OFFERVERSION_VIEW_QUERY = gql(`
  query ViewWlOfferVersion($id: Int!) {
    viewWlOfferVersion(id: $id) {
      ...WLOfferVersionListView
    }
  }
`);

export const OFFERVERSION_VIEW_DOWNPAYMENT_QUERY = gql(`
  query ViewWlOfferVersionDownpayment($id: Int!) {
    viewWlOfferVersion(id: $id) @connection(key: "viewWlOfferVersionDownpayment", filter: ["id"]) {
      offer {
        downpaymentDueDate
        downpaymentAmount
        downpaymentRemark
      }
    }
  }
`);

export const OFFERVERSION_VIEW_CANCELLATION_RULES_QUERY = gql(`
  query ViewWlOfferVersionCancellationRules($id: Int!) {
    viewWlOfferVersion(id: $id) @connection(key: "viewWlOfferVersionCancellationRules", filter: ["id"]) {
      offer {
        cancellationToleranceRate
        cancellationRules {
          id
          daysToEvent
          minOvernight
          maxOvernight
          minTotalGuests
          maxTotalGuests
          rate
        }
      }
    }
  }
`);

export const OFFERVERSION_QUICKPRICE_QUERY = gql(`
  query OfferVersionQuickPriceDehydrate($id: Int!) {
    offerVersionQuickPriceDehydrate(id: $id)
  }
`);

export const OFFERVERSION_PRODUCTTEXT_QUERY = gql(`
  query OfferVersionProductTextDehydrate($id: Int!) {
    offerVersionProductTextDehydrate(id: $id)
  }
`);

export const OFFERVERSION_UPSERT_MUTATION = gql(`
  mutation UpsertOfferVersion($id: Int!, $data: WLOfferVersionInput!, $client: QuickPriceClient, $switchServiceTypeSku: String, $savePrices: Boolean!, $approve: Boolean!, $crHasPriceChanges: Boolean) {
    upsertOfferVersion(id: $id, data: $data, client: $client, switchServiceTypeSku: $switchServiceTypeSku, savePrices: $savePrices, approve: $approve, crHasPriceChanges: $crHasPriceChanges) {
      ...WLOfferVersionListView
    }
  }
`);

export const OFFERVERSION_RESET_MUTATION = gql(`
  mutation ResetOfferVersion($id: Int!) {
    resetOfferVersion(id: $id)
  }
`);

export const OFFERVERSION_APPROVE_MUTATION = gql(`
  mutation ApproveWlOfferVersion($offerVersionId: Int!) {
    approveOfferVersion(offerVersionId: $offerVersionId) {
      ...WLOfferVersionListView
    }
  }
`);

export const OFFERVERSION_REJECT_MUTATION = gql(`
  mutation RejectWlOfferVersion(
    $offerVersionId: Int!
    $rejectionReason: OfferRejectionReasonInput!
  ) {
    rejectOfferVersion(
      offerVersionId: $offerVersionId
      rejectionReason: $rejectionReason
    )
  }
`);

export const OFFERVERSION_CONFIRM_CANCELLATION_MUTATION = gql(`
  mutation ConfirmCancellationHotel($offerVersionId: Int!) {
    confirmCancellationHotel(offerVersionId: $offerVersionId) {
      ...WLOfferVersionListView
    }
  }
`);

export const OFFERVERSION_PROCESSEVENTSTARTED_MUTATION = gql(`
  mutation ProcessOfferVersionEventStarted($offerVersionId: Int!) {
    processOfferVersionEventStarted(offerVersionId: $offerVersionId)
  }
`);

export const OFFERVERSION_PROCESSEVENTENDED_MUTATION = gql(`
  mutation ProcessOfferVersionEventEnded($offerVersionId: Int!) {
    processOfferVersionEventEnded(offerVersionId: $offerVersionId)
  }
`);

export const OFFERVERSION_DELETE_MUTATION = gql(`
  mutation DeleteWlOfferVersion($offerVersionId: Int!, $deleteReason: String!) {
    deleteOfferVersion(offerVersionId: $offerVersionId, deleteReason: $deleteReason)
  }
`);

export const OFFERVERSION_CANCEL_SEM_MUTATION = gql(`
  mutation CancelSEMOfferVersion($id: Int!, $data: WLOfferVersionInput!, $client: QuickPriceClient) {
    cancelSEMOfferVersion(id: $id, data: $data, client: $client) {
      ...WLOfferVersionListView
    }
  }
`);

export const OFFERVERSION_UPDATE_CANCELLATION_RULES_MUTATION = gql(`
  mutation UpdateOfferCancellationRules($offerVersionId: Int!, $rules: [WLOfferCancellationRuleInput!]!, $cancellationToleranceRate: Float) {
    updateOfferCancellationRules(offerVersionId: $offerVersionId, rules: $rules, cancellationToleranceRate: $cancellationToleranceRate)
  }
`);

export const OFFERVERSION_UPDATE_DOWNPAYMENT_MUTATION = gql(`
  mutation UpdateOfferDownpayment($offerVersionId: Int!, $downpaymentDueDate: Date, $downpaymentAmount: Float, $downpaymentRemark: String) {
    updateOfferDownpayment(offerVersionId: $offerVersionId, downpaymentDueDate: $downpaymentDueDate, downpaymentAmount: $downpaymentAmount, downpaymentRemark: $downpaymentRemark)
  }
`);

export const OFFERVERSION_UPDATE_COMMISSION_MUTATION = gql(`
  mutation UpdateOfferCommission($offerVersionId: Int!, $commissionBase: EOfferCommissionBase!, $commissionPercentage: Float!) {
    updateOfferCommission(offerVersionId: $offerVersionId, commissionBase: $commissionBase, commissionPercentage: $commissionPercentage)
  }
`);

export const PRECALCULATE_OFFERVERSION_COMMISSION = gql(`
  query PrecalculateOfferVersionCommission($offerVersionId: Int!) {
    precalculateOfferVersionCommission(id: $offerVersionId) {
      commissionBase
      commissionBaseAmount
      commissionPercentage
      commissionAmountNet
      commissionAmountGross
    }
  }
`);

export const OFFER_SEND_REMINDER_CLIENT_MUTATION = gql(`
  mutation SendOfferReminderEmailClient($offerVersionId: Int!) {
    sendOfferReminderEmailClient(offerVersionId: $offerVersionId)
  }
`);

export const RESEND_OFFER_EMAIL_CLIENT_MUTATION = gql(`
  mutation ResendOfferEmailClient($offerVersionId: Int!) {
    resendOfferEmailClient(offerVersionId: $offerVersionId)
  }
`);

export const OFFER_CREATE_MUTATION = gql(`
  mutation CreateOffer($hotelId: Int!, $input: QuickPriceInput!, $client: QuickPriceClient!) {
    createOffer(hotelId: $hotelId, input: $input, client: $client) {
      ...WLOfferListShort
    }
  }
`);

export const DUPLICATE_OFFER_MUTATION = gql(`
  mutation DuplicateOffer($offerVersionId: Int!, $startDate: CalendarDate!) {
    duplicateOffer(offerVersionId: $offerVersionId, startDate: $startDate) {
      offerId
      offerVersionId
      refCode
    }
  }
`);

export const OFFER_CREATE_LISTER_MUTATION = gql(`
  mutation CreateOfferLister($hotelId: Int!, $input: QuickPriceInputLister!, $client: QuickPriceClient!) {
    createOfferLister(hotelId: $hotelId, input: $input, client: $client) {
      ...WLOfferListShort
    }
  }
`);

export const OFFER_PREVIEW_HTML_QUERY = gql(`
  query OfferQuickInputHtmlPreview($hotelId: Int!, $source: EOfferSource!, $input: QuickPriceInput!, $client: QuickPriceClient!) {
    offerQuickInputHtmlPreview(hotelId: $hotelId, source: $source, input: $input, client: $client) {
      html
    }
  }
`);
export const QUICKPRICE_DEHYDRATE_QUERY = gql(`
  query QuickPriceDehydrate($hotelId: Int!) {
    quickPriceDehydrate(hotelId: $hotelId)
  }
`);

export const QUICKPRICE_DEHYDRATE_LISTER_QUERY = gql(`
  query QuickPriceDehydrateLister($hotelId: Int!) {
    quickPriceDehydrateLister(hotelId: $hotelId)
  }
`);

export const EVENT_DETAILS_FRAGMENT = gql(`
  fragment AMEventDetailsOutput on AMEventOutput {
    id
    active
    askForOvernight
    eventName
    expiryDate
    welcomeText
    logoFilename
    accessToken
    coachInvoicingRule
    noshowInvoicingRule
    serviceDirectPay
    roomDirectPay
    extraDirectPay
    parkingDirectPay
    accountingAreaId
    costCentreId
    commentRooms
    commentPayment
    commentAccomodation
    commentOther
    attendances {
      id
      profile {
        id
        firstname
        lastname
      }
      comment
      invoicingRule
      serviceDirectPay
      roomDirectPay
      extraDirectPay
      parkingDirectPay
      accountingAreaId
      costCentreId
      days {
        id
        day
        attending
        forenoon
        morning
        lunch
        afternoon
        dinner
        room
        coach
        invoicingRule
        serviceDirectPay
        roomDirectPay
        extraDirectPay
        parkingDirectPay
        comment
        accountingAreaId
        costCentreId
      }    
    }
    eventDays {
      id
      day
      morningTime
      forenoonTime
      lunchTime
      afternoonTime
      dinnerTime
      comment
      rooms {
        id
        sequence
        fromTime
        toTime
        seating
        guestCount
        label
        commentFacilities
      }    
    }
  }
`);

export const EVENT_VIEW_QUERY = gql(`
  query ViewWlOfferEvent($offerId: Int!) {
    viewWlOfferEvent(offerId: $offerId) {
      ...AMEventDetailsOutput
    }
  }
`);

export const LIST_OFFER_FILES_ADMIN_QUERY = gql(`
  query ListOfferFilesAdmin($offerId: Int!) {
    listOfferFilesAdmin(offerId: $offerId) {
      id
      originalFilename
      createdAt
    }
  }
`);

export const SUBSCRIPTION_OFFER_CHANGED_SHORT = gql(`
  subscription OnOfferChangedShort($offerId: Int!) {
    offerChanged(offerId: $offerId) {
      ...WLOfferListShort
    }
  }
`);

export const SUBSCRIPTION_OFFER_CHANGED_DETAILS = gql(`
  subscription OnOfferChangedDetails($offerId: Int!) {
    offerChanged(offerId: $offerId) {
      ...WLOfferListView
    }
  }
`);

/**
 * Evict every Apollo cache field that surfaces offer / offer-version data so
 * the bookings list, booking detail, search and report views refetch after an
 * offer mutation. Without these, only the offer editor itself would refresh
 * (via REFETCH_OFFER_QUERIES) and dependent views would keep showing stale
 * dates / status.
 *
 * Calling cache.evict({ fieldName }) without args evicts every variation
 * (every page, every filter combination), then gc() drops orphaned objects so
 * cached `latestVersion` / `editingVersion` references don't linger.
 */
export const EVICT_OFFER_QUERIES = (cache: ApolloCache<any>) => {
  cache.evict({ fieldName: 'listWlOffers' });
  cache.evict({ fieldName: 'listWlOfferVersions' });
  cache.evict({ fieldName: 'listWlOfferVersionsByIds' });
  cache.evict({ fieldName: 'reportOffersList' });
  cache.evict({ fieldName: 'listBookings' });
  cache.evict({ fieldName: 'viewBooking' });
  cache.evict({ fieldName: 'listOverflows' });
  cache.gc();
};

/**
 * Returns list of queries to refetch after offer mutations.
 * Includes offer and version queries based on provided IDs.
 */
export const REFETCH_OFFER_QUERIES = (offerId?: number | undefined, offerVersionId?: number | undefined) => [
  ...(offerId
    ? [
      {
        query: OFFER_VIEW_QUERY,
        variables: { id: offerId },
      },
    ]
    : []),
  ...(offerVersionId
    ? [
      {
        query: OFFERVERSION_VIEW_QUERY,
        variables: { id: offerVersionId },
      },
    ]
    : []),
];

export const HLBOOKINGOVERFLOW_LIST_SHORT_FRAGMENT = gql(`
  fragment HLBookingOverflowOutput on HLBookingOverflowOutput {
    id
    createdAt
    updatedAt
    refCode
    originalTitle
    originalStartDate
    originalEndDate
    comment
    booking {
      id
      refCode
      status
      title
      input {
        startDate
        endDate
        days {
          day
          totalGuests
          overnightRoomsEZ
          overnightRoomsDZ
        }
      }
      publicClient {
        id
        firstname
        lastname
      }
      publicCompany {
        id
        name
      }
    }
    notifications {
      id
      notificationDate
      comment
      hotel {
        id
        name
        refCode
      }
    }
    firstNotification {
      id
      notificationDate
      comment
      hotel {
        id
        name
        refCode
      }
    }
  }
`);

export const LIST_OVERFLOWS_QUERY = gql(`
  query ListOverflows($search: String, $skip: Int, $take: Int) {
    listOverflows(search: $search, skip: $skip, take: $take) {
      totalCount
      overflows {
        ...HLBookingOverflowOutput
      }
    }
  }
`);

export const EXPORT_OVERFLOWS_QUERY = gql(`
  query ExportOverflows($search: String, $headers: [String]) {
    exportOverflows(search: $search, headers: $headers) {
      filecontent
      isBase64
      filename
      contentType
    }
  }
`);

export const UPLOAD_OFFER_DOCUMENT = gql(`
  mutation UploadOfferDocument($offerVersionId: Int!, $filename: String!, $base64: String!, $mimeType: String) {
    uploadOfferDocument(offerVersionId: $offerVersionId, filename: $filename, base64: $base64, mimeType: $mimeType) {
      id
      originalFilename
      fileSize
      createdAt
    }
  }
`);

export const REMOVE_OFFER_DOCUMENT = gql(`
  mutation DeleteOfferDocument($offerId: Int!, $fileId: Int!) {
    deleteOfferDocument(offerId: $offerId, fileId: $fileId)
  }
`);

export const LIST_OFFER_DOCUMENTS = gql(`
  query OfferDocuments($offerId: Int!) {
    offerDocuments(offerId: $offerId) {
      id
      originalFilename
      fileSize
      createdAt
    }
  }
`);

export const LIST_AVAILABLE_HOTEL_STANDARD_DOCUMENTS = gql(`
  query AvailableHotelStandardDocuments($offerId: Int!) {
    availableHotelStandardDocuments(offerId: $offerId) {
      id
      displayName
      approved
      documentFile {
        id
        originalFilename
        fileSize
        mimeType
      }
    }
  }
`);

export const LIST_SELECTED_OFFER_STANDARD_DOCUMENTS = gql(`
  query OfferStandardDocuments($offerId: Int!) {
    offerStandardDocuments(offerId: $offerId) {
      id
      displayName
      documentFile {
        id
        originalFilename
        fileSize
      }
    }
  }
`);

export const SET_OFFER_STANDARD_DOCUMENT = gql(`
  mutation SetOfferStandardDocument($offerId: Int!, $hotelDocumentId: Int!, $selected: Boolean!) {
    setOfferStandardDocument(offerId: $offerId, hotelDocumentId: $hotelDocumentId, selected: $selected)
  }
`);

export const SPACES_LIST_QUERY = gql(`
  query ListSpaces {
    listSpaces {
      ...SpaceFull
    }
  }
`);

export const LIST_HOTELS_FOR_REPORTS_QUERY = gql(`
  query ListHotelsForReports($spaceId: Int, $hotelId: Int, $skip: Int, $take: Int) {
    listHotels(spaceId: $spaceId, hotelId: $hotelId, skip: $skip, take: $take) {
      hotels {
        ...HotelListView
      }
    }
  }
`);

export const LIST_BOOKINGS_FOR_REPORTS_QUERY = gql(`
  query ListBookingsForReports($spaceId: Int, $skip: Int, $take: Int, $status: String) {
    listBookings(spaceId: $spaceId, skip: $skip, take: $take, status: $status) {
      id
      refCode
      title
      status
      createdAt
      updatedAt
      publicCompany {
        id
        name
        isPremium
        country
      }
      publicClient {
        id
        firstname
        lastname
        email
        country
      }
      input {
        startDate
        endDate
      }
      offers {
        id
        refCode
        status
        hotel {
          id
          name
          refCode
          spaceId
          businessCountry
          businessState
           contracts {
            id
            type
            isActive
            validFrom
            validTo
          }
        }
      }
    }
  }
`);

export const REPORT_LIST_HOTEL_GROUPS_QUERY = gql(`
  query ReportListHotelGroups {
    reportListHotelGroups {
      id name
    }
  }
`);

export const REPORT_LIST_HOTEL_STATES_QUERY = gql(`
  query ReportListHotelStates($country: ECountryCode) {
    reportListHotelStates(country: $country)
  }
`);

export const REPORT_LIST_HOTELS_QUERY = gql(`
  query ReportListHotels($id: Int, $country: ECountryCode, $state: String, $groupIds: [Int!], $contractType: ContractType, $name: String, $skip: Int, $take: Int) {
    reportListHotels(id: $id, country: $country, state: $state, groupIds: $groupIds, contractType: $contractType, name: $name, skip: $skip, take: $take) {
      id name businessName businessZip businessCity businessCountry businessState
      contracts { id type isActive validFrom validTo }
      groups { id name }
    }
  }
`);

export const REPORT_LIST_PUBLIC_COMPANIES_QUERY = gql(`
  query ReportListPublicCompanies($id: Int, $country: ECountryCode, $isPremium: Boolean, $name: String, $skip: Int, $take: Int) {
    reportListPublicCompanies(id: $id, country: $country, isPremium: $isPremium, name: $name, skip: $skip, take: $take) {
      id name zip city country isPremium
    }
  }
`);

export const REPORT_LIST_PUBLIC_CLIENTS_QUERY = gql(`
  query ReportListPublicClients($id: Int, $country: ECountryCode, $isPremium: Boolean, $publicCompanyId: Int, $name: String, $skip: Int, $take: Int) {
    reportListPublicClients(id: $id, country: $country, isPremium: $isPremium, publicCompanyId: $publicCompanyId, name: $name, skip: $skip, take: $take) {
      id firstname lastname email country
      publicCompany { id name zip city country isPremium }
    }
  }
`);

export const REPORT_OFFERS_LIST_COUNT_QUERY = gql(`
  query ReportOffersListCount($filters: OffersReportFiltersInput!) {
    reportOffersListCount(filters: $filters)
  }
`);

export const REPORT_OFFER_LIST_VIEW_FRAGMENT = gql(`
  fragment ReportWLOfferListView on WLOfferListOutput {
    id
    createdAt
    status
    source
    process
    language
    offerCode
    refCode
    commissionAmountNet
    commissionAmountGross
    bookingId
    bookingTitle
    space { ...SpaceShort }
    hotel {
      id
      name
      spaceId
      integrations { id }
    }
    booking {
      id
      refCode
      title
      status
      createdAt
      updatedAt
      publicClient {
        id
        firstname
        lastname
        email
      }
    }
    publicCompany {
      id
      name
      country
      isPremium
    }
    client {
      id
      firstname
      lastname
      email
    }
    requestedBy
    input {
      startDate
      endDate
      prevdayGuests
      days {
        day
        totalGuests
        overnightGuests
      }
    }
    inputLister {
      startDate
      endDate
      days {
        day
        totalGuests
        overnightRoomsEZ
        overnightRoomsDZ
      }
    }
    latestVersionReport {
      id
      status
      type
    }
    latestVersion {
      totalPriceNet
      totalPriceGross
    }      
    ivApprovedAt
  }
`);

export const REPORT_OFFERS_LIST_QUERY = gql(`
  query ReportOffersList($filters: OffersReportFiltersInput!, $sort: [OffersReportSortInput!], $skip: Int, $take: Int) {
    reportOffersList(filters: $filters, sort: $sort, skip: $skip, take: $take) {
      ...ReportWLOfferListView
    }
  }
`);

export const REPORT_HOTEL_CONTRACTS_LIST_COUNT_QUERY = gql(`
  query ReportHotelContractsListCount($filters: HotelContractsReportFiltersInput!) {
    reportHotelContractsListCount(filters: $filters)
  }
`);

export const REPORT_HOTEL_CONTRACTS_LIST_QUERY = gql(`
  query ReportHotelContractsList($filters: HotelContractsReportFiltersInput!, $sort: [HotelContractsReportSortInput!], $skip: Int, $take: Int) {
    reportHotelContractsList(filters: $filters, sort: $sort, skip: $skip, take: $take) {
      id
      refCode
      name
      businessName
      businessZip
      businessCity
      businessState
      businessCountry
      showInLister
      contracts {
        id
        type
        validFrom
        validTo
        invoiceInterval
        amountCents
        isActive
        nextInvoiceDate
      }
      groups {
        id
        name
      }
    }
  }
`);

export const REPORT_EARLYBIRD_QUERY = gql(`
  query ReportEarlyBird($country: ECountryCode, $date: Date!, $premium: Boolean) {
    reportEarlyBird(country: $country, date: $date, premium: $premium) {
      rangeDayFrom
      rangeDayTo
      rangeWeekFrom
      rangeWeekTo
      rangeMonthFrom
      rangeMonthTo
      rangeYearFrom
      rangeYearTo
      day {
        offerCount
        bookingCount
        reservationCount
        totalAmountNet
        totalAmountGross
        commissionAmountNet
        commissionAmountGross
      }
      week {
        offerCount
        bookingCount
        reservationCount
        totalAmountNet
        totalAmountGross
        commissionAmountNet
        commissionAmountGross
      }
      month {
        offerCount
        bookingCount
        reservationCount
        totalAmountNet
        totalAmountGross
        commissionAmountNet
        commissionAmountGross
      }
      year {
        offerCount
        bookingCount
        reservationCount
        totalAmountNet
        totalAmountGross
        commissionAmountNet
        commissionAmountGross
      }
    }
  }
`);

export const REPORT_STATISTICS_LIST_QUERY = gql(`
  query ReportStatisticsList($filters: StatisticsReportFiltersInput!, $skip: Int, $take: Int) {
    reportStatisticsList(filters: $filters, skip: $skip, take: $take) {
      requestYear
      requestMonth
      hotelId
      hotelName
      offerSource
      eventYear
      eventMonth
      totalRequests
      approvedCount
      rejectedByHotelCount
      rejectedByClientCount
      totalNights
      totalGuests
    }
  }
`);

export const REPORT_STATISTICS_COUNT_QUERY = gql(`
  query ReportStatisticsCount($filters: StatisticsReportFiltersInput!) {
    reportStatisticsCount(filters: $filters)
  }
`);

export const REPORT_STATISTICS_BOOKINGS_QUERY = gql(`
  query ReportStatisticsBookings($filters: StatisticsReportBookingsFiltersInput!) {
    reportStatisticsBookings(filters: $filters) {
      id
      refCode
      title
      status
      createdAt
      publicClient {
        id
        firstname
        lastname
        email
      }
      publicCompany {
        id
        name
      }
      input {
        startDate
        endDate
        days {
          day
          totalGuests
          overnightRoomsEZ
          overnightRoomsDZ
        }
      }
      responsibleUser {
        id
        name
      }
      offers {
        id
        hotel {
          id
          name
          refCode
          spaceId
        }
        status
        latestVersionReport {
          id
          status
        }
        history {
          id
          status
          createdAt
          user {
            id
            name
            spaceId
          }
          publicClient {
            id
            firstname
            lastname
          }
        }
      }
    }
  }
`);

export const REPORT_STATISTICS_OFFERS_QUERY = gql(`
  query ReportStatisticsOffers($filters: StatisticsReportBookingsFiltersInput!) {
    reportStatisticsOffers(filters: $filters) {
      id
      refCode
      offerCode
      createdAt
      status
      source
      hotel {
        id
        name
        refCode
        spaceId
      }
      publicCompany {
        id
        name
      }
      publicClient {
        id
        firstname
        lastname
      }
      latestVersionReport {
        id
        status
      }
      booking {
        id
        refCode
        responsibleUser {
          id
          name
        }
        publicClient {
          id
          firstname
          lastname
        }
        input {
          startDate
          endDate
          days {
            totalGuests
            overnightRoomsEZ
            overnightRoomsDZ
          }
        }
      }
      history {
        id
        status
        createdAt
        user {
          id
          name
          spaceId
        }
        publicClient {
          id
          firstname
          lastname
        }
      }
    }
  }
`);

export const REPORT_CONTACT_OVERVIEW_COUNT_QUERY = gql(`
  query ReportContactOverviewCount($filters: ContactOverviewReportFiltersInput!) {
    reportContactOverviewCount(filters: $filters)
  }
`);

export const REPORT_CONTACT_OVERVIEW_LIST_QUERY = gql(`
  query ReportContactOverviewList($filters: ContactOverviewReportFiltersInput!, $sort: [ContactOverviewReportSortInput!], $skip: Int, $take: Int) {
    reportContactOverviewList(filters: $filters, sort: $sort, skip: $skip, take: $take) {
      id
      contactPersonName
      contactPersonId
      companyName
      companyId
      timestamp
      subject
      contactSubjectId
      employeeName
      employeeId
      contactType
    }
  }
`);
export const REPORT_CONTACT_PERSON_COUNT_QUERY = gql(`
  query ReportContactPersonCount($filters: ContactPersonReportFiltersInput!) {
    reportContactPersonCount(filters: $filters)
  }
`);

export const REPORT_CONTACT_PERSON_LIST_QUERY = gql(`
  query ReportContactPersonList($filters: ContactPersonReportFiltersInput!, $sort: [ContactPersonReportSortInput!], $skip: Int, $take: Int) {
    reportContactPersonList(filters: $filters, sort: $sort, skip: $skip, take: $take) {
      id
      title
      firstname
      lastname
      address
      streetNumber
      zip
      city
      country
      state
      addressSupplement
      email
      phone
      mobile
      subjects
      netInquiries
      grossRequests
      reservations
      overnightStays
      participants
      publicCompanyId
      companyName
    }
  }
`);
